export const resume = {
	title: "Resumen",
	description:
		"Verifique si toda la información está correcta y después publique la promoción. Será activada automáticamente y ya estará lista para uso.",
	sections: {
		allProducts: "Todos los productos",
		andMore: "y más {{count}} productos",
		promotionInfo: {
			title: "Datos de la promoción",
			name: "Nombre",
			description: "Descripción",
			maxUses: {
				label: "Cantidades de usos por ganancia",
				uses: "{{uses}} usos",
				withoutLimits: "Sin límites",
			},
			places: "Locales",
		},
		goals: {
			title: "Metas",
			frequency: "Recurrencia de ganancias",
		},
		awards: {
			title: "Premios",
			discount: "Descuento(%) sobre el valor del producto",
			products: "Productos del descuento",
		},
		usageConditions: "Condiciones del uso",
	},
};
